import React, { useState } from 'react'
import moment from 'moment'
import { moneyize } from '../../../../../onestep-library/TextPresenters'
import { useSelector, useDispatch } from 'react-redux'
import { refundCharge } from '../actions'
import { ClipLoader } from 'react-spinners'
import classnames from 'classnames'

function ChargeListing(props){
  const { amount, description, created_at, status, payment_source, is_refunded, paid_at } = props
  const isMuted = is_refunded || isChargeFailed(status);

  return(
    <tr>
      <td className={classnames({'text-muted': isMuted})}>{moment(created_at).format("MM/D/YYYY")}</td>
      <td className={classnames({'text-muted': isMuted})}>{moment(paid_at).format("MM/D/YYYY")}</td>
      <td className={classnames({'text-muted': isMuted})}>{moneyize(amount)}</td>
      <td className={classnames({'text-muted': isMuted})}>{payment_source.name}</td>
      <td className={classnames({'text-muted': isMuted})}>{description}</td>
      <td><ChargeStatus {...props} /></td>
    </tr>
  )
}

const ChargeStatus = ({ is_refunded, status, pay_simple_failure, is_refunding, id }) => {
  if (isChargeFailed(status)) {
    const settlement_description = pay_simple_failure?.settlement_description;
    return <div className="text-danger">Failed - {settlement_description}</div>;
  }
  return <ChargeRefund {...{ is_refunded, is_refunding, id }} />
}

const ChargeRefund = ({ is_refunded, is_refunding, id }) => {
  const dispatch = useDispatch()
  const [ confirmRefund, setConfirmRefund ] = useState(false)

  const handleClickRefund = () => {
    if (!confirmRefund){
      setConfirmRefund(true)
      setTimeout(()=>{setConfirmRefund(false)},3000)
    } else {
      dispatch(refundCharge(id))
      setConfirmRefund(false)
    }
  }

  if (is_refunded) {
    return <div className="text-muted">Refunded</div>
  }
  return <button disabled={is_refunding} onClick={handleClickRefund} className={`btn ${confirmRefund ? 'btn-danger' : 'btn-warning'}`}>
    { is_refunding ? <ClipLoader color="#ffffff" size={14}/> : (
      confirmRefund ? 'Confirm' : 'Refund'
    )}
  </button>;
}

const isChargeFailed = (status) => status === 'failed';

export default ChargeListing
